import CookieConsent from "react-cookie-consent";

const CookieBanner = () => {
  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    if (typeof window !== "undefined" && window.loadYandexMetrica) {
      window.loadYandexMetrica();
    }
  };

  const handleDecline = () => {
    localStorage.setItem("cookie-consent", "declined");
  };

  return (
    <CookieConsent
      location="bottom"
      buttonText="ПРИНЯТЬ"
      declineButtonText="ОТКЛОНИТЬ"
      cookieName="cookie-consent"
      enableDeclineButton
      flipButtons
      onAccept={handleAccept}
      onDecline={handleDecline}
      expires={365}
      style={{
        background: "#120F0D",
        color: "#F2E9DE",
        fontFamily: "'Outfit', sans-serif",
        fontSize: "0.88rem",
        fontWeight: 300,
        padding: "1rem 1.75rem",
        borderTop: "1px solid rgba(242, 233, 222, 0.08)",
        alignItems: "center",
        gap: "1.25rem",
        zIndex: 9999,
      }}
      buttonStyle={{
        background: "transparent",
        color: "#F2E9DE",
        border: "1px solid #E57324",
        borderRadius: 0,
        padding: "0.65rem 1.75rem",
        fontFamily: "'Outfit', sans-serif",
        fontSize: "0.75rem",
        fontWeight: 500,
        letterSpacing: "0.18em",
        cursor: "pointer",
        textTransform: "uppercase",
        transition: "all 0.35s ease",
        whiteSpace: "nowrap",
      }}
      declineButtonStyle={{
        background: "transparent",
        color: "#A99F96",
        border: "1px solid rgba(242, 233, 222, 0.15)",
        borderRadius: 0,
        padding: "0.65rem 1.75rem",
        fontFamily: "'Outfit', sans-serif",
        fontSize: "0.75rem",
        fontWeight: 400,
        letterSpacing: "0.18em",
        cursor: "pointer",
        textTransform: "uppercase",
        transition: "all 0.35s ease",
        whiteSpace: "nowrap",
      }}
      contentStyle={{
        flex: "1 1 auto",
        maxWidth: "720px",
        lineHeight: 1.6,
      }}
      buttonWrapperClasses="cookie-buttons-wrapper"
      overlay={false}
    >
      Мы используем cookie-файлы и сервис Яндекс.Метрика для анализа трафика и улучшения работы сайта.{" "}
      <span
        style={{
          color: "#A99F96",
          fontSize: "0.82rem",
        }}
      >
        Нажимая «Принять», вы соглашаетесь на обработку данных в соответствии с{" "}
        <a
          href="/privacy"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#E57324",
            textDecoration: "none",
            borderBottom: "1px solid rgba(229, 115, 36, 0.35)",
            transition: "border-color 0.3s",
          }}
          onMouseEnter={(e) =>
            (e.target.style.borderBottomColor = "#E57324")
          }
          onMouseLeave={(e) =>
            (e.target.style.borderBottomColor = "rgba(229, 115, 36, 0.35)")
          }
        >
          Политикой конфиденциальности
        </a>
        .
      </span>
    </CookieConsent>
  );
};

export default CookieBanner;
